import React from 'react';
import ReactPlayer from 'react-player';

export const CustomReactPlayer = ({ url, style, width, height, onError }) => (
  <ReactPlayer
    config={{
      file: {
        attributes: {
          controlsList: 'nodownload  noremoteplayback noplaybackrate',
          disablepictureinpicture: 'true',
        },
      },
    }}
    onContextMenu={(e) => e.preventDefault()}
    width={width}
    height={height}
    controls
    url={url}
    style={style}
    onError={onError}
  />
);
